import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Divider,Button, message } from "antd";
import * as XLSX from "xlsx";
import { createpettycash, createpettycashinBulk } from "../../actions/accounting/pettycash";
import moment from 'moment';

const Excelimport = ({createpettycash, createpettycashinBulk}) => {
  const [items, setItems] = useState([]);

  const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws, {
          raw: false,
         });
        // console.log(data);
        resolve(data);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise.then((d) => {
      setItems(d);
    });
  };
  const dateFormat = "YYYY-MM-DD";
  const format = 'h:mm a';
  const format24 = 'HH:mm';
  const onConfirm = () => {
    // create an empty array
    const updatedItems = [];
    items.forEach(data =>{
      let date = String(data.date);
      // console.log(date);
      date = new Date(date);
      // console.log(date);
      date = moment(date).format(dateFormat);

      let entryTime = moment(data.entryTime, format);
      entryTime = entryTime.format(format24);
      let exitTime = moment(data.exitTime, format);
      exitTime = exitTime.format(format24);
      let isAttended = data.isAttended == "TRUE" ? true : false;
      const value = {
        'issue_date': data.issue_date,
        'employee': data.employee_id,
        'amount': data.amount,
        'location': data.location_id,
        'narration': data.narration,
        'increase': true,
        'day_allowance': data.day_allowance,
        'night_allowance': data.night_allowance,
        'overtime_allowance': data.overtime_allowance,
      };
      // push value to the array
      updatedItems.push(value);
    
      // createpettycash(value);
    });
    createpettycashinBulk({"entries": updatedItems}).then((res)=>{
        // message.info(res);
    });
    // message.success(
    //   "Petty Cash Updated"
    // );
  };
  return (
    <div>
      <input
        type="file"
        onChange={(e) => {
          const file = e.target.files[0];
          readExcel(file);
        }}
      />
      <Button type="primary" onClick={onConfirm}>
          Update
        </Button>
      <Divider />
      <table className="table_import">
        <tr className="table_heading">
          <th scope="col">issue_date</th>
          <th scope="col">employee_id</th>
          <th scope="col">employee_name</th>
          <th scope="col">amount</th>
          <th scope="col">location_id</th>
          <th scope="col">location_name</th>
          <th scope="col">day_allowance</th>
          <th scope="col">night_allowance</th>
          <th scope="col">overtime_allowance</th>
          <th scope="col">narration</th>
        </tr>

        {items.map((e) => {
          return (
            <tr>
              <td>{e.issue_date}</td>
              <td>{e.employee_id}</td>
              <td>{e.employee_name}</td>
              <td>{e.amount}</td>
              <td>{e.location_id  }</td>
              <td>{e.location_name}</td>
              <td>{e.day_allowance}</td>
              <td>{e.night_allowance}</td>
              <td>{e.overtime_allowance}</td>
              <td>{e.narration}</td>
            </tr>
          );
        })}
      </table>
    </div>
  );
};

export default connect(null, { createpettycash, createpettycashinBulk })(Excelimport);
